import {uuid} from 'uuidv4';
import ActionsMixin from './ActionsMixin.js';
import SyncingMixin from './SyncingMixin.js';
import UndoMixin from './UndoMixin.js';

class OperationManager extends UndoMixin(SyncingMixin(ActionsMixin)) {
    constructor(sequencerEngine) {
        super(sequencerEngine);
        this.sequencerEngine = sequencerEngine;
        this.uuids = new Set();
    }

    async dispatch(action, isSyncedOperation=false, isBatch=false) {
        if (!isSyncedOperation &&
            this.roomActionsManager &&
            this.roomActionsManager.actionsRemaining <= 0) {
            // User has reached limit of actions allowed so
            // simply don't execute this action
            return {}; 
        }
        let copiedAction = this.makeCopyOfAction(action);
        if (this.getAction(action) === undefined) {
            return {};
        }

        let ret = await this.runAction(action, !isBatch, isSyncedOperation);
        copiedAction.payload = {... copiedAction.payload, ...ret};
        if (!isSyncedOperation) {
            await this.logAction(copiedAction);
        }
        return ret;
    };

    runAction(action, updateRedux=true, isSyncedOperation) {
        let actionToRun = this.getAction(action);
        if (actionToRun === undefined) {
            return undefined;
        }
        return actionToRun.execute(action.payload, updateRedux, isSyncedOperation);
    }
}


export default OperationManager;
